export const CURRENCY_CODE_REGEX = /^[A-Z]{3}$/;

export const DEFAULT_CURRENCY_CODE = 'USD';

export const ERROR_MESSAGES = {
  NOT_AVAILABLE: 'The selected currency is not available.',
  SAVE_FAILED: 'Unable to save currency preference. Please try again.',
  PARTIAL_SAVE: 'Currency preference partially saved. Please try again.',
} as const;
